import React from 'react'
import styles from './UIGamePlayerInfoHeader.module.scss'
import {type ImageURL} from '@colonist/types'
import {UIGamePlayerInfoHeaderPointsPublic} from './UIGamePlayerInfoHeaderPointsPublic/UIGamePlayerInfoHeaderPointsPublic.tsx'
import clsx from 'clsx'
import {UIGamePlayerInfoHeaderPointsPrivate} from './UIGamePlayerInfoHeaderPointsPrivate/UIGamePlayerInfoHeaderPointsPrivate.tsx'

export interface UIGamePlayerInfoHeaderProps {
    color: string
    vpCircleColor?: string
    avatar: ImageURL
    username: string
    isMyPlayer: boolean
    isToggledEndTurn: boolean
    pointsPublic: number
    pointsPrivate?: number
    shouldUseBlackText?: boolean
}

export const UIGamePlayerInfoHeader = ({
    color,
    vpCircleColor,
    avatar,
    username,
    isMyPlayer,
    isToggledEndTurn,
    pointsPublic,
    pointsPrivate,
    shouldUseBlackText,
}: UIGamePlayerInfoHeaderProps) => {
    const isPrivatePointsVisible = pointsPrivate !== undefined && pointsPrivate > 0

    return (
        <div className={clsx(styles.wrapper, {[styles.blackText]: shouldUseBlackText})}>
            <div className={styles.pointsPublicContainer}>
                <UIGamePlayerInfoHeaderPointsPublic
                    points={pointsPublic}
                    color={vpCircleColor ?? color}
                    shouldUseBlackText={shouldUseBlackText ?? false}
                />
            </div>
            <div className={styles.container} style={{'--player-color': color} as React.CSSProperties}>
                <div className={clsx(styles.background, {
                    [styles.toggledEndTurn]: isToggledEndTurn,
                })} />
                {isPrivatePointsVisible
                    ? <div className={styles.pointsPublicAndPrivateBuffer} />
                    : <div className={styles.pointsPublicBuffer} />}
                {isPrivatePointsVisible && <div className={styles.pointsPrivateContainer}>
                    <UIGamePlayerInfoHeaderPointsPrivate points={pointsPublic + pointsPrivate} color={color} />
                </div>}
                <div className={styles.avatarContainer}>
                    <img src={avatar} className={styles.avatar} />
                </div>
                <span className={clsx(styles.username, {
                    [styles.usernameWithPrivatePoints]: isPrivatePointsVisible,
                })}>{username}</span>
            </div>
        </div>
    )
}
